import { Link } from "wouter";
import { LogoMark } from "@/components/public/logo-mark";
import { Container } from "@/components/public/institutional-ui";

/** Minimal footer per client brief */
export function Footer() {
  return (
    <footer className="border-t border-border bg-background relative z-10">
      <Container className="py-14 md:py-16">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12">
          <div>
            <Link href="/" className="inline-block mb-6 hover:opacity-80 transition-opacity">
              <LogoMark size="sm" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              Private credit and structured capital for ambitious businesses in India.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-10 text-sm">
            <div className="space-y-3 text-muted-foreground">
              <p className="gc-eyebrow text-muted-foreground">Contact</p>
              <a
                href="mailto:support@godmancapital.in"
                className="block text-foreground hover:opacity-60 transition-opacity"
              >
                support@godmancapital.in
              </a>
              <p>
                11th Floor, Raheja Tower
                <br />
                MG Road, Bangalore – 560001
              </p>
              <a
                href="https://www.linkedin.com/company/godman-capital"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block hover:text-foreground transition-colors"
              >
                LinkedIn
              </a>
            </div>

            <div className="space-y-3 text-muted-foreground sm:text-right">
              <p className="gc-eyebrow text-muted-foreground sm:text-right">Legal</p>
              <span className="block cursor-pointer hover:text-foreground transition-colors">
                Privacy Policy
              </span>
              <span className="block cursor-pointer hover:text-foreground transition-colors">
                Terms of Use
              </span>
            </div>
          </div>
        </div>
      </Container>

      <div className="border-t border-border">
        <Container className="py-5 text-xs text-muted-foreground">
          © {new Date().getFullYear()} Godman Capital. All rights reserved.
        </Container>
      </div>
    </footer>
  );
}
